import { oneLine } from 'common-tags';

import { TagVariant } from './types';

import type { FunctionComponent } from 'react';
import type { TypeTagProps } from './types';

const VARIANT_MAPS: Record<TagVariant, string> = {
  [TagVariant.INFO]:
    'font-medium border-neutrals-200 bg-neutrals-0 text-neutrals-500',
  [TagVariant.PROMO]:
    'font-medium border-transparent bg-primary-100 text-primary-500',
  [TagVariant.SERVICE]:
    'font-light border-transparent bg-secondary-500 text-secondary-900',
  [TagVariant.MARKHIGHLIGHT]: '',
};

export const Tag: FunctionComponent<TypeTagProps> = ({
  className = '',
  variant,
  children,
}: TypeTagProps) => {
  if (variant === TagVariant.MARKHIGHLIGHT) {
    return (
      <span
        className={oneLine`font-accent text-text-primary inline-flex rotate-[3.69deg] items-center justify-center bg-[image:var(--mark-highlight-url,none)] bg-contain bg-center bg-no-repeat px-4 py-1 text-xl leading-none ${className} `}
      >
        {children}
      </span>
    );
  }

  return (
    <span
      className={oneLine`text-body text-body-s flex max-w-max items-center gap-1 rounded-full border px-3 py-1.5 ${VARIANT_MAPS[variant]} ${className} `}
    >
      {children}
    </span>
  );
};

Tag.displayName = 'Tag';
